import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, formValueSelector } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  BannerComponent,
  Card,
  Checkbox,
  IconList,
  LevelNav,
  ProgressBar,
} from 'common/components';
import { capitalizeString } from 'common/utils';
import { toCommaNumber } from 'common/formatters';
import * as formatters from 'common/formatters';
import { ACTIVITY_TYPES } from 'common/constants';

const ContractsForm = props => {
  const { onSubmit, contracts, selectedCrop, activityType } = props;

  const getContent = contract => {
    const {
      deliveryDate,
      crop,
      quantity: { contracted },
    } = contract;
    let list = [
      {
        label: `${crop.name} ${crop.variety ? crop.variety : ''}`,
        icon: 'crop',
      },
      {
        label: `${toCommaNumber(contracted.size)} ${capitalizeString(
          contracted.type
        )}`,
        icon: 'storagefill',
      },
      { label: `${formatters.date(deliveryDate)}`, icon: 'calendar' },
    ];
    return list;
  };

  const shouldMatchVariety =
    activityType !== ACTIVITY_TYPES.HARVESTING &&
    activityType !== ACTIVITY_TYPES.DELIVERY;

  const match = selectedCrop && JSON.parse(selectedCrop);
  let selectedContract = match
    ? contracts.filter(
        contract =>
          contract.crop.name === match.name &&
          (!shouldMatchVariety || contract.crop.variety === match.variety)
      )
    : contracts;
  // alphabetical order
  if (selectedContract && selectedContract.legnth > 1) {
    selectedContract.sort((a, b) =>
      a.company < b.company ? -1 : a.company > b.company ? 1 : 0
    );
  }

  return (
    <Fragment>
      <BannerComponent
        theme={['static', 'strong', 'large', 'mobile-fixed']}
        message={
          <LevelNav
            nav={{
              left: {
                label: <span className={'visible--desktop'}>Back</span>,
                action: () => onSubmit(),
              },
              center: { label: 'Add Contract' },
            }}
          />
        }
      />

      <form>
        {selectedContract && selectedContract.length === 0 && (
          <p className={'text--center text--medium'}>
            No Contracts with {match.name} {match.variety}
          </p>
        )}

        {selectedContract && selectedContract.length > 0 && (
          <Fragment>
            <p className={'text--fade'}>
              <small>Select contracts from the list below to add.</small>
            </p>

            <div className={'field'}>
              <Checkbox
                name={'contracts'}
                theme={['card']}
                onChange={onSubmit}
                options={selectedContract.map(contract => {
                  const {
                    id,
                    company,
                    quantity: { contracted, delivered, pending },
                  } = contract;

                  return {
                    value: JSON.stringify({
                      id,
                      name: company,
                      type: id.split(':')[0],
                      max: pending.size,
                    }),
                    label: (
                      <Card
                        footer={
                          contracted && (
                            <ProgressBar
                              label={{ used: 'Delivered', free: 'Pending' }}
                              value={delivered.size}
                              max={contracted.size}
                              unit={contracted.type.slice(0, 2)}
                            />
                          )
                        }
                      >
                        <h3 className={'cardlist__title'}>{company}</h3>
                        <IconList list={getContent(contract)} />
                      </Card>
                    ),
                  };
                })}
              />
            </div>
          </Fragment>
        )}
      </form>
    </Fragment>
  );
};

ContractsForm.propTypes = {
  // from redux form
  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,

  // from mapstate
  selectedCrop: PropTypes.string,

  // manually added
  onSubmit: PropTypes.func.isRequired,
  contracts: PropTypes.arrayOf(PropTypes.object),
  activityType: PropTypes.string,
};

ContractsForm.defaultProps = {
  activityType: '',
};

const formSettings = {
  form: 'activityform',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onChange: (values, dispatch, props, prevValues) => {
    props.populateAmount('contracts', values, dispatch, prevValues);
  },
};
const field = formValueSelector(formSettings.form);
const mapState = state => ({
  selectedCrop: field(state, 'crop'),
});

export default compose(
  reduxForm(formSettings),
  connect(mapState)
)(ContractsForm);



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/forms/Contracts.js